import { Box } from '@chakra-ui/react';
import { CheckboxListFilter } from '@components/cockpit/panels/CheckboxListFilter';
import { getStatusFilterCheckboxItems } from '@components/cockpit/panels/monitoring/filters/statusFilter.items';

import { CriticalityCategoryEnum } from '../monitoring.types';
import { useMonitoringContext } from '../MonitoringContext';

export function StatusFilter() {
  const { state, setStatus, countByStatusFilter } = useMonitoringContext();
  const { statusCategories } = state;

  const allStatus = statusCategories.size === Object.values(CriticalityCategoryEnum).length;
  const noStatus = statusCategories.size === 0;

  const isChecked = (status: CriticalityCategoryEnum) => statusCategories.has(status);
  const onChange = (status: CriticalityCategoryEnum) => {
    const newSet = new Set(statusCategories);
    newSet.has(status) ? newSet.delete(status) : newSet.add(status);
    setStatus(newSet);
  };
  const statusesCheckboxItems = getStatusFilterCheckboxItems(isChecked, onChange, countByStatusFilter);

  return (
    <Box padding={2} width="100%">
      <CheckboxListFilter
        items={statusesCheckboxItems}
        actionAll={{
          disabled: allStatus,
          onClick: () => !allStatus && setStatus(new Set(Object.values(CriticalityCategoryEnum))),
        }}
        actionNone={{
          disabled: noStatus,
          onClick: () => !noStatus && setStatus(new Set()),
        }}
      />
    </Box>
  );
}
